const INITIAL_STATE = { data: [], selectedUser: '', text: '', broadcastText: '', messageTitle: '' };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FETCH_DATA':
            return { ...state };
        case 'FETCH_DATA_SUCCESS':
            return { ...state, data: action.payload };
        case 'FETCH_DATA_FAIL':
            return { ...state };
        case 'TIME':
            return { ...state, time: action.payload };
        case 'DATE':
            return { ...state, date: action.payload };
        case 'USER_SELECTION':
            return { ...state, selectedUser: action.payload };
        case 'QUESTION_SELECTION':
            return { ...state, selectedQuestion: action.payload };
        case 'TEXT_CHANGE':
            return { ...state, text: action.payload };
        case 'TEXT_CLEAR':
            return { ...state, text: '' };
        case 'BROADCAST_TEXT_CLEAR':
            return { ...state, broadcastText: '', messageTitle: '' };
        case 'BROADCAST_MESSAGE_CHANGE':
            return { ...state, broadcastText: action.payload };
        case 'BROADCAST_MESSAGE_CLEAR':
            return { ...state, broadcastText: '', messageTitle: '' };
        case 'MESSAGE_TITLE_CHANGE':
            return { ...state, messageTitle: action.payload };
        case 'SEND_MESSAGE':
            return { ...state };
        case 'SEND_MESSAGE_SUCCESS':
            return { ...state };
        case 'SEND_MESSAGE_FAIL':
            return { ...state };
        case 'PUSH_MESSAGE':
            return { ...state };
        case 'PUSH_MESSAGE_SUCCESS':
            return { ...state };
        case 'PUSH_MESSAGE_FAIL':
            return { ...state };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ChatList/ChatListReducer.js